import { Flex } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import './App.css'
import LoginIllustration from './assets/images/Login3.svg'
import LogoWhite from './assets/images/logoWhite.png'
import ActionBox from './components/ActionBox/ActionBox'
import Background from './components/Background/Background'
import Button from './components/Button/Button'
import CTA from './components/CTA/CTA'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import HeroText from './components/HeroText/HeroText'
import IslandContainer from './components/IslandContainer/IslandContainer'
import MoreTools from './components/MoreTools/MoreTools'
import Promotions from './components/Promotions/Promotions'
import PromotionsFlyout from './components/PromotionsFlyout/PromotionsFlyout'
import StepsContentNeo from './components/StepsContentNeo/StepsContentNeo'
import useCheckLimit from './hooks/useCheckLimit'
import WhyRecootySection from './components/WhyRecootySection/WhyRecootySection'
import AiJobInterviewSection from './components/AiJobInterviewSection/AiJobInterviewSection'
import FAQAccordion from './components/FAQAccordion/FAQAccordion'

function App() {
  const [limitExceeded, setLimitExceeded] = useState(false)

  const limitChecked = useCheckLimit()

  useEffect(() => {
    setTimeout(() => {
      setLimitExceeded(limitChecked)
    }, 500)
  }, [limitChecked])

  const handleLClick = (limitSet) => {
    if (limitSet) {
      setLimitExceeded(true)
    }
  }

  //For Promotional content auto expiry on Black friday
  const [promoValid, setPromoValid] = useState(true)

  useEffect(() => {
    const currentDate = new Date()
    const targetDate = new Date('2023-11-24')

    console.log(currentDate)

    if (currentDate > targetDate) {
      setPromoValid(false)
    }

    const timer = setInterval(() => {
      if (new Date() > targetDate) {
        setPromoValid(false)
        clearInterval(timer)
      }
    }, 1000)

    return () => clearInterval(timer) // This is to clear interval when the component unmounts
  }, [])

  //Scroll to More Tools section
  const moreToolsSection = useRef(null)

  const handleScrollDown = () => {
    moreToolsSection.current.scrollIntoView({ behavior: 'smooth' })
  }

  // Show explore more features CTA while in progress
  const [result, setResult] = useState('')

  const handleResult = (val) => {
    setResult(val)
  }

  return (
    <>
      <div className="Container">
        <div className="BodyContainer">
          <div className="AccentBar"></div>
          <Header />

          <HeroText result={result} />

          <IslandContainer resultVal={handleResult} limitSet={handleLClick} />

          {(result === 2 || result === 3) && (
            <CTA
              heading="Explore Our More AI Hiring Tools"
              buttonIcon="arrow_downward"
              buttonText="Check it out"
              onClick={handleScrollDown}
              small
            />
          )}

          <StepsContentNeo />

          <div ref={moreToolsSection} />
          <MoreTools />

          <Flex alignItems="center" flexDirection="column" width="100%">
            <div className="ASeparator" />
            <div className="ActionBox">
              <ActionBox
                icon="description"
                content="Do you want to explore our library of 500+ curated email templates?"
                button="View All Templates"
                link="https://recooty.com/blog/job-descriptions/"
              />

              <ActionBox
                icon="psychology"
                content="Explore our next-gen hiring tools powered by AI."
                button="Explore HR Tools"
                link="https://recooty.com/hr-tools"
              />
            </div>
          </Flex>
          <WhyRecootySection />
          {promoValid && (
            <PromotionsFlyout
              element={
                <a href="https://dash.recooty.com/register?referral=ultra">
                  <Promotions />
                </a>
              }
            />
          )}
          <AiJobInterviewSection />
          <FAQAccordion />
          <Footer />
        </div>
      </div>

      {/* Usage Limiter Modal */}
      {limitExceeded && (
        <Background isActive={limitExceeded} center frostedGlass>
          <div className="LExhaustContainer">
            <Button
              variant="SmallButton"
              className="CloseButton"
              leftIcon="close"
              onClick={() => setLimitExceeded(false)}
            ></Button>
            <div className="LEShowcase">
              <img src={LogoWhite} alt="Recooty logo" />
              <h3>Supercharge your recruitment game with AI.</h3>
              <span>Reduce your time & cost per hire by upto 75%.</span>
              <ul>
                <li>
                  <span className="material-symbols-outlined">task_alt</span>
                  Unlimited AI Hiring tools access
                </li>
                <li>
                  <span className="material-symbols-outlined">task_alt</span>
                  Post jobs to 200+ job boards
                </li>
                <li>
                  <span className="material-symbols-outlined">task_alt</span>
                  Schedule interviews & hire
                </li>
                <li>
                  <span className="material-symbols-outlined">task_alt</span>
                  Track & manage candidates
                </li>
                <li>
                  <span className="material-symbols-outlined">task_alt</span>
                  Build beautiful career pages
                </li>
                <li>
                  <span className="material-symbols-outlined">task_alt</span>
                  Resume Parsing
                </li>
              </ul>
            </div>
            <div className="LEMessage">
              <h5>Oops, you've exhausted your daily free trial limit.</h5>
              <h3>Get unlimited access</h3>
              <img
                src={LoginIllustration}
                alt="Sign up to Recooty to avail unlimited outputs"
              />
              <a href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Fdash.recooty.com%2F">
                <Button variant="HeroButton">Get a Free 14-Day Trial</Button>
              </a>
            </div>
          </div>
        </Background>
      )}
    </>
  )
}

export default App
